<template>
  <b-modal
      centered
      no-close-on-esc
      hide-header
      hide-footer
      no-close-on-backdrop
      class="cy-client-intake-cropper-modal"
      title="Upload Profile Picture"
      v-model="showCropper"
    >
    <b-container fluid>
      <div>
        <p>Adjust the image before uploading it.</p>
      </div>
      <div>
        <img
          id="image"
          :src="fileURL"
          ref="source"
          class="cropper-hidden w-100"
        />
      </div>

      <div class="d-flex justify-content-end">
        <b-button
          v-if="!isLoading"
          class="cy-client-intake-cropper-cancel cropper-btn btn-primary px-5 py-3 btn-pill mt-3 mb-3"
          @click.prevent="resetModal"
          >Cancel</b-button
        >
        <b-button
          class="cy-client-intake-cropper-save cropper-btn px-5 py-3 btn-pill mt-3 mb-3"
          @click.prevent="submitImage"
          :disabled="isLoading"
        >
          <b-spinner
            v-if="isLoading"
            style="width: 14px; height: 14px"
            variant="light"
            label="Spinning"
          ></b-spinner>
          {{ `${!isLoading ? "Save" : ""}` }}
        </b-button>
      </div>
    </b-container>
  </b-modal>
</template>

<script>
import Cropper from "cropperjs"
import _ from "lodash";

export default {
  props: {
    showCropper: { type: Boolean },
    fileURL: { type: String },
    isLoading: { type: Boolean },
  },

  mounted() {
    this.setupCropperInstance()
  },

  data() {
    return {
      canvas: null,
      debouncedUpdatePreview: _.debounce(this.updatePreview, 257),
    }
  },

  methods: {
    updatePreview() {
      this.canvas = this.cropper.getCroppedCanvas()
    },

    async setupCropperInstance() {
      await this.$nextTick()
      const image = this.$refs.source

      this.cropper = new Cropper(image, {
        crop: this.debouncedUpdatePreview,
        autoCropArea: 1,
        aspectRatio: 1,
        viewMode: 0,
        scalable: false,
        zoomable: false
      })
    },

    resetModal() { this.$emit('close-and-clear-modal') },

    async submitImage() {
      const blob = await getBlob(this.canvas)
      this.$emit('update-image-blob', blob)

      this.resetModal()

      // todo: move to helpers file
      async function getBlob(canvas) {
        return new Promise((resolve) => {
          canvas.toBlob(function(blob) { resolve(blob) })
        })
      }
    }
  }
}
</script>

<style>

</style>